import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_FAILURE,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_SUCCESS,

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CLEAR,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_FILTER,

    TrialInstitutionLaboratoryFinanceAction
} from '../actions/trialInstitutionLaboratoryFinance';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialInstitutionLaboratoryFinanceState {
    formData: Dtos.TrialInstitutionLaboratoryFinance | Dtos.TrialInstitutionLaboratoryFinance[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    validateState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialInstitutionLaboratoryFinance[];
    formLength: number;
}

const initialState: ITrialInstitutionLaboratoryFinanceState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ITrialInstitutionLaboratoryFinanceState, _isLoading: boolean): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ITrialInstitutionLaboratoryFinanceState,
    formData: Dtos.TrialInstitutionLaboratoryFinance | Dtos.TrialInstitutionLaboratoryFinance[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: ITrialInstitutionLaboratoryFinanceState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: ITrialInstitutionLaboratoryFinanceState, formFilter: IFormFilter): ITrialInstitutionLaboratoryFinanceState {

    const items: Dtos.TrialInstitutionLaboratoryFinance[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (
            formFilter.search == "" ||
            p.accountNumber.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1
        )) : undefined;

    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: ITrialInstitutionLaboratoryFinanceState, propertiesToClear?: string[]): ITrialInstitutionLaboratoryFinanceState {

    if (!propertiesToClear) {
        const newState: ITrialInstitutionLaboratoryFinanceState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialInstitutionLaboratoryFinanceState, _isSaving: boolean): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialInstitutionLaboratoryFinanceState,
    formData: Dtos.TrialInstitutionLaboratoryFinance | Dtos.TrialInstitutionLaboratoryFinance[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialInstitutionLaboratoryFinanceState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function validating(state: ITrialInstitutionLaboratoryFinanceState, _isValidating: boolean): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialInstitutionLaboratoryFinanceState,
    formData: Dtos.TrialInstitutionLaboratoryFinance | Dtos.TrialInstitutionLaboratoryFinance[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialInstitutionLaboratoryFinanceState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialInstitutionLaboratoryFinanceState, _isCreating: boolean): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialInstitutionLaboratoryFinanceState,
    formData: Dtos.TrialInstitutionLaboratoryFinance,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialInstitutionLaboratoryFinanceState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryFinanceState {
    const newState: ITrialInstitutionLaboratoryFinanceState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

const TrialInstitutionLaboratoryFinanceReducer: Reducer<ITrialInstitutionLaboratoryFinanceState> = (state: ITrialInstitutionLaboratoryFinanceState = initialState, action: TrialInstitutionLaboratoryFinanceAction) => {
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID:
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE:
            return saving(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE:
            return creating(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_FILTER:
            return filter(state, action.formFilter);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC:
            return loading(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SYNC_FAILURE:
            return loadFailure(state, action.responseStatus);

    }

    return state;
}

export default TrialInstitutionLaboratoryFinanceReducer;